import AboutMe from '../components/ui/AboutMe.js';
import LastestProject from '../components/ui/LastestProject.js';
import ContactMe from '../components/ui/ContactMe.js';

function HomePage() {
    return(
        <div>
            <AboutMe/>
            <LastestProject/>
            <ContactMe/>
        </div>
    );
}

export default HomePage;